module.exports = __webpack_public_path__ + "img/seo-content-collapsible-kia.1f71bff0.png";